
import React from "react";
import {
  Grid,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast } from "../../../utilities/SnackBarUtils";
import { MatchContext } from "../../../contexts/MatchContext";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";



const GroupsByRound = ({groups, refresh}) => {
      const { getData } = React.useContext(MatchContext);
      const { attendees } = React.useContext(EventContext);
      const [selectedUser, setSelectedUser] = React.useState(null);
      const [showAddDialog, setShowAddDialog] = React.useState(false);
      const [addData, setAddData] = React.useState(null);
      const [attendeeToAdd, setAttendeeToAdd] = React.useState(null);

      const handleRemove = async () => {
        const body = {
          action: "remove",
          userId: selectedUser.attendee._id,
          groupId: selectedUser.groupId,
        };
        const result = await request("pairingevent/updategroup", "post", body);
        if (result.success) {
          refresh();
          toast.success("User removed from group");
          getData();
        }
    
        setSelectedUser(null);
      };
    
      const closeAddDialog = () => {
        setAddData(null);
        setAttendeeToAdd(null);
        setShowAddDialog(false);
      };
    
      const handleAdd = async () => {
        const body = {
          action: "add",
          userId: attendeeToAdd,
          groupId: addData.groupId,
        };
        const result = await request("pairingevent/updategroup", "post", body);
        if (result.success) {
          refresh();
          toast.success("User added to group");
          getData();
        }
        setAddData(null);
        setAttendeeToAdd(null);
        setShowAddDialog(false);
      };

      return (
        <>
          <Grid container justifyContent="space-between">
            <Grid item xs={12}>
              {groups.map((round, r) => {
                return (
                  <Accordion key={`round-${r}`} TransitionProps={{ unmountOnExit: true }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Round: {round?.round}</Typography>
                    </AccordionSummary>
                    <AccordionDetails >
                      {round.groups.map((group, g) => {
                        return (
                          <Accordion key={`group-${g}`} TransitionProps={{ unmountOnExit: true }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography>Table: {group?.table}</Typography>
                            </AccordionSummary>
                            <AccordionDetails >
                              <List>
                                {group.users.map((attendee, a) => {
                                  return (
                                    <ListItem
                                      key={`${a}-${attendee._id}`}
                                      style={{ width: "100%" }}
                                    >
                                      <div
                                        style={{
                                          width: "100%",
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <ListItemText>
                                          {attendee?.profile?.firstName}{" "}
                                          {attendee?.profile?.lastName}
                                        </ListItemText>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          onClick={() =>
                                            setSelectedUser({
                                              attendee,
                                              groupId: group._id,
                                            })
                                          }
                                        >
                                          Remove
                                        </Button>
                                      </div>
                                    </ListItem>
                                  );
                                })}
                              </List>
                              <div
                                style={{
                                  marginTop: 15,
                                  marginBottom: 10,
                                  width: "100%",
                                  paddingLeft: "20%",
                                  paddingRight: "20%",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  onClick={() => {
                                    setAddData({ groupId: group._id });
                                    setShowAddDialog(true);
                                  }}
                                >
                                  Add to Group
                                </Button>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Grid>
            {/* <Grid item xs={2}>
              <Button onClick={handleEmail}>Email</Button>
            </Grid> */}
          </Grid>
          <Dialog
            open={selectedUser ? true : false}
            onClose={() => setSelectedUser(null)}
          >
            <DialogTitle>Confirm Removal</DialogTitle>
            <DialogContent>
              Are you sure you want to remove{" "}
              <span style={{ fontWeight: "bold" }}>
                {selectedUser?.attendee?.profile?.firstName}
              </span>{" "}
              from the group?
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSelectedUser(null)}>Cancel</Button>
              <Button onClick={handleRemove}>Remove</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={showAddDialog} onClose={closeAddDialog}>
            <DialogTitle>Add Attendee to Group</DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <Typography>
                Select an attendee from the dropdown and then click save
              </Typography>
              <FormControl fullWidth>
                <InputLabel style={{ top: -5 }}>Attendee</InputLabel>
                <Select
                  value={attendeeToAdd || ""}
                  label="Select Attendee"
                  onChange={(e) => {
                    setAttendeeToAdd(e.target.value);
                  }}
                  style={{ height: 45 }}
                >
                  {attendees.map((option) => {
                    return (
                      <MenuItem key={option._id} value={option._id}>
                        {option?.profile?.firstName} {option?.profile?.lastName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddDialog}>Cancel</Button>
              <Button onClick={handleAdd}>Save</Button>
            </DialogActions>
          </Dialog>
        </>
      );


}

export default GroupsByRound;